import React from 'react';
import useRequired from '../../hooks/useRequired';
import InputControlMask from '../controls/InputControlMask';
import  Tooltip from './Tooltip';
import ReactTooltip from "react-tooltip";
import { ImgInfo } from '../../svg/reclamo';
import {IoIosSearch} from 'react-icons/io';

const Input = ({ 
        id, 
        field='',
        label, 
        type = 'text',
        placeholder='', 
        value='', 
        classNameContainer = '',
        classNameInput = '',
        onChange=()=>'',
        mask = '',
        pattern=undefined, 
        title='',
        required=true,
        icon=undefined,
        usetooltip = false,
        tooltipText = "",
        tooltipTitle = "",
        classTitle = "",
        useiconSearch = false,
        onClickIconSearch = () => '',
    }) => {

       

    let classi = "";
    if(label ==="") classi = "sg-input-field-no-label-nr";

    const cssClassContainer = `${classNameContainer}  sg-input `;
    const cssClassInput = `${classNameInput}  sg-input-field ${classi}`; 
    const cssLabelTitle = "labelTitle " +classTitle;
    
    const control = {
        textarea: <textarea 
                rows="2" 
                id={id}
                name={field}     
                onChange={onChange} 
                className={cssClassInput}
                type={type} 
                placeholder={placeholder} 
                value={value} 
                required={required}
            ></textarea>,
        text: <input           
            id={id}
            name={field}     
            onChange={onChange} 
            className={cssClassInput}
            type={type} 
            placeholder={placeholder} 
            value={value} 
            required={required}
            pattern={pattern}
            title={title}
        />,
        email: <input           
            id={id}
            name={field}     
            onChange={onChange} 
            className={cssClassInput}
            type={type} 
            placeholder={placeholder} 
            value={value} 
            required={required}
            pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"
            
        />,
        number: <input           
            id={id}
            name={field}     
            onChange={onChange} 
            className={cssClassInput}
            type={type} 
            placeholder={placeholder} 
            value={value} 
            required={required}
        />,
        maskInput:<InputControlMask  
            name={field} 
            onChange={onChange} 
            className={cssClassInput}
            type={type} 
            id={id} 
            placeholder={placeholder} 
            value={value} 
            required={required}
            mask={mask} 
            pattern={pattern}
            title={title}
        />
    }


    /*

    */

    return (
        <div className={cssClassContainer}>
             
                
            {usetooltip ===true && 
            <div className="label-with-info">
                     <label htmlFor={id} className={cssLabelTitle}>{label} {icon}</label>
                        <Tooltip title={tooltipTitle} text={tooltipText} />
                        </div>
               
            }
          
            {usetooltip ===false &&
            <label htmlFor={id} className="labelComponent">{label} {icon}</label>
            }
            
            {
                control[type]               
            }
            { useiconSearch === true && (
               <IoIosSearch className="icon-search-nr" onClick={onClickIconSearch}/>
            )

            }          
        </div>
    );
}



export default Input;
